import { useState } from 'react'

import PropTypes from 'prop-types'
import { Chip, Button, Grid } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import clsx from 'clsx'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { MenuButton } from 'components'

import { DialogCertificate } from './components'
import {
  UserCompaniesForm,
  UserCompanyRemoveLinkingDialog,
} from '../../components'
import UserChangeStatusDialog from '../../../UserChangeStatusDialog'

import constants from 'constants/index'

import useStyles from '../../../TableRowUsers/styles'

const UserCompaniesTable = ({ user, userCompanies, refresh, isLoading }) => {
  const [linkedCompany, setLinkedCompany] = useState(false)
  const [linkedCompanyStatus, setLinkedCompanyStatus] = useState(false)
  const [removeLinkingCompany, setRemoveLinkingCompany] = useState(false)
  const [currentUserCompany, setCurrentUserCompany] = useState({})

  const classes = useStyles()

  const handleEdit = (userCompany) => {
    setCurrentUserCompany(userCompany)
    setLinkedCompany(true)
  }

  const handleChangeStatus = (userCompany) => {
    setCurrentUserCompany(userCompany)
    setLinkedCompanyStatus(true)
  }

  const handleRemoveLinking = (userCompany) => {
    setCurrentUserCompany(userCompany)
    setRemoveLinkingCompany(true)
  }

  const disabledEdit = (userCompany) =>
    userCompany?.company?.kind === constants.companies.KIND_SUPPLIER ||
    userCompany?.profile?.id === constants.profile.PROFILE_ID_RESPONSIBLE

  return isLoading ? (
    <Grid container>
      <Grid item xs={12}>
        <Skeleton variant="rect" height={55} />
      </Grid>
    </Grid>
  ) : (
    <>
      <Table emptyMessage="Não há empresas vinculadas">
        <TableHead>
          <TableRow>
            <TableCell width="10%">ID</TableCell>
            <TableCell width="35%">Empresa</TableCell>
            <TableCell width="30%">Perfil</TableCell>
            <TableCell width="15%">Status</TableCell>
            <TableCell width="10%">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {userCompanies?.map((userCompany, index) => (
            <TableRow key={userCompany?.id || index} hover>
              <TableCell disableTooltip>{userCompany?.id}</TableCell>
              <TableCell>{userCompany?.company?.name}</TableCell>
              <TableCell>{userCompany?.profile?.name}</TableCell>
              <TableCell disableTooltip>
                <Chip
                  className={clsx(classes.root, {
                    [classes.active]:
                      userCompany?.status === constants.userCompanies.ACTIVE,
                    [classes.inactive]:
                      userCompany?.status === constants.userCompanies.INACTIVE,
                  })}
                  align="center"
                  size="small"
                  label={
                    userCompany?.status === constants.userCompanies.ACTIVE
                      ? 'Ativo'
                      : 'Inativo'
                  }
                />
              </TableCell>
              <TableCell disableTooltip>
                <MenuButton>
                  <Button
                    onClick={() => handleEdit(userCompany)}
                    fullWidth
                    size="small"
                    disabled={disabledEdit(userCompany)}
                  >
                    Editar
                  </Button>
                  <Button
                    onClick={() => handleChangeStatus(userCompany)}
                    fullWidth
                    size="small"
                  >
                    {userCompany?.status === constants.userCompanies.ACTIVE
                      ? 'Inativar'
                      : 'Ativar'}
                  </Button>
                  <DialogCertificate
                    userCompany={userCompany}
                    refresh={refresh}
                  >
                    Certificado
                  </DialogCertificate>
                  <Button
                    onClick={() => handleRemoveLinking(userCompany)}
                    fullWidth
                    size="small"
                  >
                    Excluir
                  </Button>
                </MenuButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {currentUserCompany?.id && (
        <>
          <UserCompaniesForm
            setOpen={setLinkedCompany}
            refresh={refresh}
            open={linkedCompany}
            currentUserCompany={currentUserCompany}
            isEdit
          />
          <UserChangeStatusDialog
            user={user}
            userCompany={currentUserCompany}
            isCollaborator={false}
            open={linkedCompanyStatus}
            setOpen={setLinkedCompanyStatus}
            refresh={refresh}
          />
          <UserCompanyRemoveLinkingDialog
            currentUserCompany={currentUserCompany}
            open={removeLinkingCompany}
            setOpen={setRemoveLinkingCompany}
            refresh={refresh}
          />
        </>
      )}
    </>
  )
}

UserCompaniesTable.propTypes = {
  userCompanies: PropTypes.arrayOf(Object),
  user: PropTypes.object,
  refresh: PropTypes.func,
}

export default UserCompaniesTable
